import React from 'react';
import {
    Input,
    InputGroup,
    FormControl,
    CheckOutlined,
    Box,
    Paragraph,
} from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { Styled } from './ShareModal.styled';

export const ShareModalReady: React.FC<{
    creatorUrl: string;
    hasBeenCopied: boolean;
    onClick: () => void;
}> = ({ creatorUrl, hasBeenCopied, onClick }): JSX.Element => (
    <>
        <Paragraph contrast="low">
            <Trans>
                Copy the link to share your track with friends, fans and
                collaborators.
            </Trans>
        </Paragraph>
        <FormControl isValid={hasBeenCopied} isReadOnly>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                width="100%"
            >
                <Styled.CopyInputGroup>
                    <Input value={creatorUrl}></Input>
                    <InputGroup.Addon placement="right" padding={0}>
                        <Styled.CopyButton
                            variant="primary"
                            onClick={onClick}
                            icon={hasBeenCopied && CheckOutlined}
                        >
                            {!hasBeenCopied && <Trans>Copy</Trans>}
                        </Styled.CopyButton>
                    </InputGroup.Addon>
                </Styled.CopyInputGroup>
                <FormControl.ValidationMessage>
                    <Trans>Copied to clipboard!</Trans>
                </FormControl.ValidationMessage>
            </Box>
        </FormControl>
    </>
);
